<template>

    <div class="alert-modal">
        <Popup :class-name="showPopup ? 'open' : ''" :closeable="true"
               @closePopup="closePopup">
            <h4 class="popup-title" :class="[titleClass]">{{ title }}</h4>
            <div class="popup-content my-2">{{ content }}</div>
            <div class="buttons">
                <v-btn type="button" class="popup-btn" @click="closePopup">OK</v-btn>
            </div>
        </Popup>
    </div>

</template>

<script>
    import Popup from '../../common/Popup';

    export default {
        components: {
            Popup,
        },
        props: {
            title: {
                type: String,
            },
            titleClass: {
                type: String,
            },
            content: {
                type: String,
            },
        },
        data() {
            return {
                showPopup: true,
            }
        },
        methods: {
            closePopup() {
                this.showPopup = !this.showPopup;
                this.$emit('close');
            },
        }
    }
</script>

<style lang="scss">
@import "../../../style/Charts/ViewChart/AlertModalComponent";
</style>
